import { render } from "./VabeneTransactionListPage.vue?vue&type=template&id=413dfba2&ts=true"
import script from "./VabeneTransactionListPage.vue?vue&type=script&lang=ts"
export * from "./VabeneTransactionListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__